import chroma from 'chroma-js';

export { MAP_DAE_COLORS_5, MAP_SEVERITY_COLORS_5, MAP_SPRAY_COLORS_5 } from '@protector/entities/choropleth/constants';
export type { ChoroplethLimits, StorageMaxDaysLimit } from '@protector/entities/choropleth/models';

export enum ChoroplethTypes {
  indicator_severity = 'indicator_severity',
  days_without_spray = 'days_without_spray',
  days_without_monitoring = 'days_without_monitoring',
  days_after_emergence = 'days_after_emergence',
  rei = 'rei',
  scouting_score = 'scouting_score',
  nematode = 'nematode',
  severity_level = 'severity_level',
  seeds = 'seeds',
  heatmap = 'heatmap',
  phenological_stage = 'phenological_stage',
  carbon_map = 'carbon_map'
}

export const LIMIT_DAYS_COLORS = [
  '#FFD9D9',
  '#F98989',
  '#CF3537',
  '#70191A',
  '#FFE4AE',
  '#E99921',
  '#9A6412',
  '#523305',
  '#C3EAD1',
  '#5EBB7F',
  '#14803C',
  '#06431C',
  '#A9EFE8',
  '#46BBB0',
  '#217C74',
  '#0D413C',
  '#C6E6FF',
  '#31B4F2',
  '#0071CD',
  '#003B69',
  '#E7DDFC',
  '#BA99F6',
  '#8354D6',
  '#462779',
  '#FFFFFF',
  '#000000'
];

export const FARMSHOTS_COLORS_256: string[] = chroma.scale(['#F85555', '#FFCA28', '#198746']).mode('lch').colors(256);

export const HEATMAP_COLORS_256: string[] = chroma.scale(['#4BF83F', '#E7EF40', '#E81021']).mode('lch').colors(256);

export const BORER_RISK_COLORS_256: string[] = chroma.scale(['#FFE7CB', '#FFC077', '#FF8A00']).mode('lch').colors(256);

const DAMAGE_RANGES = [
  { min: 0, max: 4 },
  { min: 4, max: 8 },
  { min: 8, max: 12 },
  { min: 12, max: 20 }
] as const;

export const DAMAGE_THRESHOLDS_VALUES = DAMAGE_RANGES.map(range => range.min);

const US_DAMAGE_RANGES = [
  { min: 0, max: 0.5 },
  { min: 0.5, max: 4 },
  { min: 4, max: 8 },
  { min: 8, max: 20 }
] as const;

export const US_DAMAGE_THRESHOLDS_VALUES = US_DAMAGE_RANGES.map(range => range.min);

const BR_DAMAGE_COLORS = ['#FFF1ED', '#FFB59D', '#C1462B', '#48150A'] as const;
const US_DAMAGE_COLORS = ['transparent', '#FFD42A', '#FF8C00', '#FF2327'] as const;

export const DAMAGE_THRESHOLDS = DAMAGE_RANGES.map((range, index) => ({
  ...range,
  color: BR_DAMAGE_COLORS[index]
}));

export const US_DAMAGE_THRESHOLDS = US_DAMAGE_RANGES.map((range, index) => ({
  ...range,
  color: US_DAMAGE_COLORS[index],
  disclaimer: index === 0
}));

export const DAMAGE_DEFAULT_COLOR = '#48150A';

export type DamageSeverity = 'none' | 'low' | 'moderate' | 'significant' | 'severe' | 'critical' | 'extreme';

export const COLOR_TO_SEVERITY_BR: Record<string, DamageSeverity> = {
  '#FFF1ED': 'low',
  '#FFB59D': 'moderate',
  '#C1462B': 'severe',
  '#48150A': 'extreme'
};

export const COLOR_TO_SEVERITY_US: Record<string, DamageSeverity> = {
  transparent: 'none',
  '#FFD42A': 'moderate',
  '#FF8C00': 'significant',
  '#FF2327': 'critical'
};
